"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="hero" className="relative min-h-screen w-full overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/image_rrvqg8ue.png)]">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `translateY(${scrollY * 0.5}px)`,
      willChange: "transform"
    }}>
        <video ref={videoRef} autoPlay loop muted playsInline className="h-full w-full object-cover">
          <source src="/img/turquoise_waves_jungle.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-dark-section/90 via-dark-section/60 to-transparent" />
      </div>

      {}
      <div className="relative z-10 mx-auto grid min-h-screen max-w-7xl grid-cols-1 items-center px-6 py-20 lg:grid-cols-2 lg:px-12">
        {}
        <div ref={contentRef} className={`space-y-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
        transitionDelay: "200ms"
      }}>
          <div className="space-y-4">
            <h1 className="font-display text-5xl leading-tight tracking-tight text-dark-foreground lg:text-7xl">
              Discover Luxury
              <span className="block text-primary-dark">Beyond Compare</span>
            </h1>
            <p className="max-w-xl text-lg text-dark-foreground/80 lg:text-xl">
              Immerse yourself in exclusive eco-luxury experiences where
              Caribbean elegance meets authentic adventure in the heart of
              Riviera Maya.
            </p>
          </div>

          <div className="flex flex-col gap-4 sm:flex-row">
            <Link to="/ToursPage">
              <Button size="lg" className="group btn-primary transition-all duration-[var(--duration-fast)] hover:scale-[1.03] hover:shadow-medium active:scale-[0.98]">
                Explore Experiences
              </Button>
            </Link>
            <Link to="/ContactPage">
              <Button size="lg" variant="outline" className="border-dark-foreground/20 bg-white/10 text-foreground backdrop-blur-md transition-all duration-[var(--duration-fast)] hover:bg-white/20 hover:shadow-medium">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div className="hidden lg:block" />
      </div>
    </section>;
}